import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ReporteBaremoService } from "../reporte-baremo.service";
import { resultadoEncuesta } from '../models/resultadoEncuesta';
import { Suggestion } from '../models/suggestion';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-reporte',
  templateUrl: './reporte.component.html',
  styleUrls: ['./reporte.component.css']
})
export class ReporteComponent implements OnInit {

  informacionParaPDF:resultadoEncuesta[]=[];
  sugerencias:Suggestion[];
  nombreEncuesta:string="Actitudes hacia la Matematica";
  urlDocsTemplate:string="";
  resultadosParaGrafica=[];
  public chart: any = null;
  id_encuesta=0;
  id_perfil=0;
  generateReport=true;
  public ENCUESTA_ESTILOS_APRENDISAJE = 3;
  public ENCUESTA_ACTITUDES_MATEMATICA = 2;

  
  constructor(private baremoService: ReporteBaremoService) { 
  }

  async ngOnInit(): Promise<void> {
    this.id_encuesta=Number(sessionStorage.getItem('encuesta'));
    this.id_perfil=Number(sessionStorage.getItem('perfil'));
    await this.getInfoPDF(this.id_encuesta,this.id_perfil);
    this.fillSuggestions();
    this.pintarGrafica();
    if (this.id_encuesta==3) {
      this.nombreEncuesta='Estilos de Aprendizaje'
    }
  }
  
  pintarGrafica(){
    if (this.id_encuesta== this.ENCUESTA_ESTILOS_APRENDISAJE) {
      this.resultadosParaGrafica=[this.informacionParaPDF[0].puntuacion, this.informacionParaPDF[2].puntuacion, this.informacionParaPDF[3].puntuacion, this.informacionParaPDF[1].puntuacion];
      this.chart = new Chart('realtime', {
        type: 'radar',
        data: {
          labels: ['Activo', 'Reflexivo', 'Teorico', 'Pragmatico'],
          datasets: [{
              label:"Resultados",
              babckgroundColor:'rgba(255,255,0,0.3);',
              data: this.resultadosParaGrafica
          }]
      },
      options : {
        scale: {
            angleLines: {
                display: false
            },
            ticks: {
                suggestedMin: 0,
                suggestedMax: 20
            }
        }
      }
    
      });
    }else{
      this.resultadosParaGrafica=[this.informacionParaPDF[1].puntuacion,this.informacionParaPDF[0].puntuacion,this.informacionParaPDF[4].puntuacion,this.informacionParaPDF[3].puntuacion,this.informacionParaPDF[2].puntuacion,0,60];
      let actitudes=['Ansiedad','Agrado','Utilidad','Motivacion','Confianza'];
      this.chart = new Chart('realtime', {
        type: 'bar',
        data: {
          labels: ['Ansiedad','Agrado','Utilidad','Motivacion','Confianza'],
          datasets: [{
              label: 'Referencia',
              backgroundColor:'rgba(0, 191, 85, 0.56)',
              barThickness: 60,
              data: this.resultadosParaGrafica
          },{
            label:'Valor obtenido',
            backgroundColor:'rgba(25, 181, 254, 1)',
            barThickness: 60,
            data: this.resultadosParaGrafica
          }
        ]
        },
        options : {
          responsive:true,
          scales: {
              xAxes: [{
                  offset:true,
                  gridLines: {
                      offsetGridLines: false
                  }
              }]
          }
        }
    
      });
    }
  }
  
  imprimirPDF(){
    this.generateReport=false;
    let resultados=[];
    let nombreEncuesta = this.id_encuesta == this.ENCUESTA_ESTILOS_APRENDISAJE ? "Estilos de Aprendisaje":"Actitudes hacia la Matematica";
    this.baremoService.getInformacionPDF(this.id_encuesta,this.id_perfil).then((response: any) => {
      let baremoVars ={};
      response.forEach(element => {
        resultados.push(element);
        baremoVars["res"+element.baremo]=element.puntuacion;
        baremoVars["interpretacion"+element.baremo]=element.interpretacion;
      });
      baremoVars["nombreEncuesta"]=nombreEncuesta;
      baremoVars["nombre"]=resultados[0].nombre;
      baremoVars["carne"]=resultados[0].registro.toString();
      baremoVars["carrera"]=resultados[0].carrera;
      baremoVars["seccion"]=resultados[0].seccion;
      baremoVars["conteoEstudiantes"]='';
      if (resultados[0].genero==1) {
        baremoVars["genero"]="Masculino";
      }else{
        baremoVars["genero"]="Femenino";
      }
      this.baremoService.getPlantilla(this.id_encuesta).then((response:any)=>{
        let idDoc=response[0].urlPlantillaReporte;
        
        let variables = {
          "id": idDoc,
          "encuesta":this.id_encuesta,
          "variables": baremoVars,
          "grafica": this.resultadosParaGrafica
        }
        console.log(variables);
        this.baremoService.getReportBase64(variables).then((response: any) => {
          this.generateReport=true;
          this.downloadPdf(response.toString(),"resultados"+resultados[0].registro.toString());
        });
      });
      
    });
    
    
  }

  downloadPdf(base64String, fileName) {
    const source = base64String;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
  }
  
  async getInfoPDF(id_encuesta,id_perfil):Promise<void>{
    await this.baremoService.getInformacionPDF(id_encuesta,id_perfil).then((response: any) => {      
      response.forEach(element => {
        let x:resultadoEncuesta=element;
        this.informacionParaPDF.push(x);
      });
    });
    console.log('fin getInfoPDF');
  }

  fillSuggestions():void{
    if (this.id_encuesta==3) {
      this.sugerencias=[
        {
          "estilo":"Activo",
          "preferencia":"Alta o muy alta",
          "caracteristicas":"Animador, improvisador, descubridor, arriesgado, espontáneo.",
          "otrasCaracteristicas":" Creativo, novedoso, renovador, inventor, protagonista, participativo, competitivo,deseoso de aprender, divertido, cambiante, conversador, generador de ideas.",
          "sugerencias":"Hacer cosas nuevas con frecuencia, leer, escuchar o debatir opiniones contrarias a la propia, cambiar de lugar con frecuencia, iniciar y mantener conversaciones con extraños o con todos los participantes en grupos o reuniones, combinar la actividad mental con actividades manuales, emitir opiniones, hablar en clase."
        },
        {
          "estilo":"Reflexivo",
          "preferencia":"Alta o muy alta",
          "caracteristicas":"Ponderado, concienzudo, receptivo, analítico, exhaustivo.",
          "otrasCaracteristicas":" Observador, paciente, cuidadoso, detallista, asimilador, prudente, distante, investigador, previsor, lento",
          "sugerencias": "Practicar la observación de las personas, hechos, fenómenos y hacer anotaciones; reflexionar sobre lo aprendido en clase y sacar conclusiones, hacer tareas minuciosas, escribir algo sobre distintos temas, pensar antes de lanzarse a la acción considerando alternativas y consecuencias"
        },
        {
          "estilo":"Teorico",
          "preferencia":"Alta o muy alta",
          "caracteristicas":"Metódico, lógico, objetivo, crítico, estructurado.",
          "otrasCaracteristicas":"Disciplinado, sistemático, ordenado, razonador, relacionador, perfeccionista, generalizador, buscador de preguntas, explorador.",
          "sugerencias":"Leer durante 30 minutos temas densos y resumir con sus propias palabras lo leído, practicar la detección de incoherencias o puntos débiles en argumentaciones orales o escritas, analizar como se ha realizado un hecho, si pudo realizarse de otra manera, comparar diversas formas de hacer lo mismo, hacer preguntas acerca de una situación y construir respuestas, descartando las respuestas vagas y confusas."
        },
        {
          "estilo":"Pragmatico",
          "preferencia":"Alta o muy alta",
          "caracteristicas":"Experimentador, práctico, directo, eficaz, realista.",
          "otrasCaracteristicas":"Técnico, decidido, planificador, objetivo, seguro de sí, organizador, solucionador de problemas, aplicador de lo aprendido",
          "sugerencias":"Investigar y analizar métodos prácticos de hacer las cosas, hacer planes de acción con límites de tiempo, ensayar nuevas formas de hacer las cosas, estudiar formas en que resuelven otras personas y hacer adaptaciones, buscar aplicaciones de lo aprendido."
        }
      ]
    }else if(this.id_encuesta==-1){
      this.sugerencias=[
        {
          "estilo":"Activo",
          "preferencia":"Alta o muy alta",
          "caracteristicas":"Animador, improvisador, descubridor, arriesgado, espontáneo.",
          "otrasCaracteristicas":" Creativo, novedoso, renovador, inventor, protagonista, participativo, competitivo,deseoso de aprender, divertido, cambiante, conversador, generador de ideas.",
          "sugerencias":"Hacer cosas nuevas con frecuencia, leer, escuchar o debatir opiniones contrarias a la propia, cambiar de lugar con frecuencia, iniciar y mantener conversaciones con extraños o con todos los participantes en grupos o reuniones, combinar la actividad mental con actividades manuales, emitir opiniones, hablar en clase."
        }
      ]
    }
  }

    
}
